export default __webpack_public_path__ + "static/0013-2687a8fc281ebeff4e9769906a52bdf8.png";